window.addEventListener("load", function() {
    const panels = document.querySelectorAll('.testimonials__panel');

    function updatePanelButtons() {
        panels.forEach(panel => {
            const quoteElement = panel.querySelector('.testimonials__quote');
            const toggleButton = panel.querySelector('.testimonials__show-more');

            const lineHeight = parseFloat(window.getComputedStyle(quoteElement).lineHeight);
            const numberOfLines = 7; // Maksymalna liczba widocznych linii
            const maxLineHeight = lineHeight * numberOfLines;

            // Tymczasowe ustawienie maxHeight, aby uzyskać poprawne scrollHeight
            quoteElement.style.maxHeight = 'none';

            // Pokaż przycisk tylko, jeśli tekst przekracza 7 pełnych linii
            if (quoteElement.scrollHeight > maxLineHeight + lineHeight * 0.5) {
                toggleButton.classList.remove('testimonials__show-more--hidden');
                quoteElement.style.maxHeight = `${maxLineHeight}px`;
            } else {
                toggleButton.classList.add('testimonials__show-more--hidden');
                quoteElement.style.maxHeight = `${quoteElement.scrollHeight}px`; // Ustawienie maxHeight na rzeczywistą wysokość tekstu
            }
        });
    }

    // Wywołaj funkcję z opóźnieniem przy ładowaniu strony
    setTimeout(updatePanelButtons, 500);

    // Wywołaj funkcję przy każdej zmianie rozmiaru okna
    window.addEventListener('resize', updatePanelButtons);

    panels.forEach(panel => {
        const quoteElement = panel.querySelector('.testimonials__quote');
        const toggleButton = panel.querySelector('.testimonials__show-more');

        toggleButton.addEventListener('click', function() {
            const lineHeight = parseFloat(window.getComputedStyle(quoteElement).lineHeight);
            const numberOfLines = 7; // Maksymalna liczba widocznych linii
            const maxLineHeight = lineHeight * numberOfLines;

            if (quoteElement.classList.contains('testimonials__quote--active')) {
                // Jeśli rozwinięty, zwijamy
                quoteElement.classList.remove('testimonials__quote--active');
                quoteElement.style.maxHeight = `${maxLineHeight}px`;
                toggleButton.textContent = 'Rozwiń';
            } else {
                // Jeśli zwinięty, rozwijamy
                quoteElement.classList.add('testimonials__quote--active');
                quoteElement.style.maxHeight = `${quoteElement.scrollHeight}px`;
                toggleButton.textContent = 'Zwiń';
            }
        });
    });
});
